var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React, { useEffect, useRef, useState } from 'react';
import loadable from '@loadable/component';
import { SelectionRegion, HandleTextSelection } from '@huridocs/react-text-selection-handler';


import { Translate } from "../../../I18N";
import { PDFJS, CMAP_URL, EventBus } from "./pdfjs";

import { triggerScroll } from "./functions/helpers";

const PDFPage = loadable(async () => import(/* webpackChunkName: "LazyLoadPDFPage" */"./PDFPage"));

const eventBus = new EventBus();










const getPDFFile = async (fileUrl) =>
PDFJS.getDocument({
  url: fileUrl,
  cMapUrl: CMAP_URL,
  cMapPacked: true,
  isEvalSupported: false
}).promise;

const PDF = ({
  fileUrl,
  highlights,
  onSelect = () => {},
  onDeselect,
  scrollToPage,
  size
}) => {
  const scrollToRef = useRef(null);
  const pdfContainerRef = useRef(null);
  const [pdf, setPDF] = useState();
  const [error, setError] = useState();

  const containerStyles = {
    height: (size === null || size === void 0 ? void 0 : size.height) || '100%',
    width: (size === null || size === void 0 ? void 0 : size.width) || '100%',
    overflow: (size === null || size === void 0 ? void 0 : size.overflow) || 'auto',
    paddingLeft: '10px',
    paddingRight: '10px'
  };

  useEffect(() => {
    getPDFFile(fileUrl).
    then((pdfFile) => {
      setPDF(pdfFile);
    }).
    catch((e) => {
      setError(e.message);
    });
  }, [fileUrl]);

  useEffect(() => {
    let animationFrameId = 0;

    if (pdf && scrollToPage) {
      animationFrameId = triggerScroll(scrollToRef, animationFrameId);
    }

    return () => {
      cancelAnimationFrame(animationFrameId);
    };
  }, [scrollToPage, pdf]);

  if (error) {
    return /*#__PURE__*/_jsx("div", {}, void 0, error);
  }

  return (/*#__PURE__*/
    _jsx(HandleTextSelection, { onSelect: onSelect, onDeselect: onDeselect }, void 0, /*#__PURE__*/
    React.createElement("div", { id: "pdf-container", ref: pdfContainerRef, style: containerStyles },
    pdf ?
    Array.from({ length: pdf.numPages }, (_, index) => index + 1).map((number) => {var _pdfContainerRef$curr;
      const regionId = number.toString();
      const pageHighlights = highlights ? highlights[regionId] : undefined;
      const shouldScrollToPage = scrollToPage === regionId;
      const containerWidth =
      ((_pdfContainerRef$curr = pdfContainerRef.current) === null || _pdfContainerRef$curr === void 0 ? void 0 : _pdfContainerRef$curr.offsetWidth) && pdfContainerRef.current.offsetWidth - 20;

      return (/*#__PURE__*/
        React.createElement("div", {
          key: `page-${regionId}`,
          id: `page-${regionId}-container`,
          ref: shouldScrollToPage ? scrollToRef : undefined }, /*#__PURE__*/

        _jsx(SelectionRegion, { regionId: regionId }, void 0, /*#__PURE__*/
        _jsx(PDFPage, {
          pdf: pdf,
          page: number,
          eventBus: eventBus,
          highlights: pageHighlights,
          containerWidth: containerWidth }
        )
        )
        ));

    }) : /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Loading")

    )
    ));

};


export default PDF;